// extracted by mini-css-extract-plugin
module.exports = {"pair":"DayWorkerAndEvent_pair__2qXES","centered":"DayWorkerAndEvent_centered__1fXoH","day":"DayWorkerAndEvent_day__1J64Y","pass":"DayWorkerAndEvent_pass__1yQrM"};